import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const EQUATIONVARIABLEGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('description', 'Entity.EquationVariableGroup.Description')
    .required()
    .minLength(1)
    .maxLength(80)
    .build(),
  FieldBuilder
    .text('name', 'Entity.EquationVariableGroup.Name')
    .required()
    .minLength(1)
    .maxLength(30)
    .build(),
];

export const EQUATIONVARIABLEGROUP_CONFIG = {
  entityName: 'EquationVariableGroup',
  localizationKey: 'General::Entity.EquationVariableGroup',
  fields: EQUATIONVARIABLEGROUP_FIELDS,
  permission: 'ControllingLiquidations.EquationVariableGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
